import React, { useState } from "react";
import { motion } from "framer-motion";
import Heading from "../../components/common/Typography/Heading";
import InteractiveText from "../../components/common/Typography/InteractiveText";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const AboutUsFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "Is Trades Poster free to use?",
      answer:
        "Yes. Customers can browse listings, contact businesses, and request quotes at no cost. Businesses pay a flat monthly fee — no commissions, no lead fees.",
    },
    {
      question: "Are the businesses on the platform verified?",
      answer:
        "We try to check every business for a valid ABN, relevant trade licence, and ID before approval. While we aim to verify thoroughly, we still recommend customers do their own checks before hiring.",
    },
    {
      question: "Can customers contact businesses directly?",
      answer:
        "Yes. Business profiles display phone numbers, emails, and links. You can also message directly through the platform.",
    },
    {
      question: "How are quotes handled?",
      answer:
        "Customers request quotes when they need a job done. There's no bidding system — businesses respond directly and set their own terms.",
    },
    {
      question: "Are reviews real?",
      answer:
        "Yes. Only customers who've made contact with a business can leave a review. We don't allow anonymous or fake reviews.",
    },
    {
      question: "Is Trades Poster available across Australia?",
      answer:
        "Yes. The platform supports listings and users in all major cities, suburbs, and regions.",
    },
  ];

  const toggleHandler = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };

  return (
    <section className={PUBLIC_SECTION_GAP_CLASS}>
      <div className="tp-container-narrow mx-auto">
        <motion.div 
          className="w-full"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
            <Heading variant={"h2"} className={"text-offblack"}>
              FAQs
            </Heading>
          </motion.div>
          
          <motion.div
            className={PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}
            variants={fadeInUp}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="border-t border-solid border-mediumgray"></div>
          </motion.div>

          <div className="space-y-0">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                className="border-b border-solid border-mediumgray"
                variants={fadeInUp}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <div
                  className="flex items-center justify-between py-6 px-4 cursor-pointer transition-colors duration-200"
                  onClick={() => toggleHandler(index)}
                >
                  <InteractiveText variant={"FAQHeader"} className="text-offblack font-medium">
                    {faq.question}
                  </InteractiveText>
                  <i
                    className={`fi ${
                      activeIndex === index ? "fi-rs-angle-up" : "fi-rs-angle-down"
                    } text-base text-offblack transition-transform duration-300 ease-in-out`}
                  />
                </div>
                
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="pb-6 px-4">
                    <InteractiveText variant={"FAQAnswer"} className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </InteractiveText>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUsFAQs; 